import * as React from "react";

import "./portalLoadingPage.less";
import { IPortalAppContext } from "../Shared/appContext";
import { PortalFullPage } from "../Shared/portalPage";

interface Props {
  context: IPortalAppContext;
  children?: React.ReactNode;
}

export function PortalLoadingPage(props: Props) {
  return (
    <PortalFullPage
      title="Loading..."
      context={props.context}
      borderedHeader={true}
      headerContent={<h1 className="loading-title">Loading ...</h1>}
      children={props.children}
    />
  );
}
